import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledButton } = Styles;

export const Button = ({ children, ...otherProps }) => (
    <StyledButton {...otherProps}>{children}</StyledButton>
);

Button.propTypes = {
    fullWidth: PropTypes.bool,
    children: PropTypes.node,
    alignment: PropTypes.string,
    padding: PropTypes.string,
};

Button.defaultProps = {
    fullWidth: false,
    children: null,
    alignment: null,
    padding: null,
};

Button.Styles = Styles;
